import { Box } from '@ltvco/refresh-lib/theme';

import { SearchTypeChip, TitleText } from '../shared/SearchForm';

import {
  RecallsCardSection,
  RecallsResultsView,
  RecallsSearchFormSection,
  RecallsSearchTypeChipsContainer,
} from './components';
import { RECALLS_PILLS, RECALLS_PILL_CONFIG } from './constants';
import { RecallsForm } from './RecallsForm';
import { useRecallsSearch } from './useRecallsSearch';

import type { FC } from 'react';

export const RecallsSearch: FC = () => {
  const {
    activePill,
    searchValue,
    savedDropdownByPill,
    activeResults,
    expandedSection,
    fdaAndUsdaRecallCards,
    consumerProductCards,
    currentPage,
    totalPages,
    pageCards,
    showPagination,
    recallsPerPage,
    sortOption,
    setSortOption,
    sortOptions,
    handleSearchValueChange,
    handleSubmit,
    handlePillClick,
    handleSearchTypeChange,
    handleCardClick,
    handleViewMore,
    handleBackFromExpanded,
    handleBackFromSearch,
    setPage,
  } = useRecallsSearch();

  return (
    <Box sx={{ width: '100%' }}>
      <RecallsSearchFormSection>
        <TitleText variant="h5" sx={{ mb: 2 }}>
          Search Recalls
        </TitleText>
        <RecallsSearchTypeChipsContainer direction="row">
          {RECALLS_PILLS.map((p) => (
            <SearchTypeChip
              key={p}
              isSelected={activePill === p}
              onClick={() => handlePillClick(p)}
              variant={activePill === p ? 'contained' : 'outlined'}
            >
              {p}
            </SearchTypeChip>
          ))}
        </RecallsSearchTypeChipsContainer>
        <RecallsForm
          key={activePill}
          searchTypeOptions={RECALLS_PILL_CONFIG[activePill].searchTypeOptions}
          fieldConfigs={RECALLS_PILL_CONFIG[activePill].fieldConfigs}
          savedDropdown={savedDropdownByPill[activePill]}
          searchValue={searchValue}
          onSearchValueChange={handleSearchValueChange}
          onSearchTypeChange={handleSearchTypeChange}
          activePill={activePill}
          onSubmit={handleSubmit}
        />
      </RecallsSearchFormSection>

      {activeResults ? (
        <RecallsResultsView
          activeResults={activeResults}
          pageCards={pageCards}
          currentPage={currentPage}
          totalPages={totalPages}
          showPagination={showPagination}
          recallsPerPage={recallsPerPage}
          sortOption={sortOption}
          sortOptions={sortOptions}
          onSortChange={setSortOption}
          onBack={
            expandedSection ? handleBackFromExpanded : handleBackFromSearch
          }
          onCardClick={handleCardClick}
          onPageChange={setPage}
        />
      ) : (
        <>
          <RecallsCardSection
            title="New Food, Drug, and Medical Device Recalls"
            cards={fdaAndUsdaRecallCards}
            onViewMore={() => handleViewMore('fdaAndUsda')}
            onCardClick={handleCardClick}
          />
          <RecallsCardSection
            title="New Consumer Product Recalls"
            cards={consumerProductCards}
            onViewMore={() => handleViewMore('cpsc')}
            onCardClick={handleCardClick}
          />
        </>
      )}
    </Box>
  );
};
